/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Any_Funny_Moments_Or_Inside_ReferencesInputs */

const en_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any Funny Moments or Inside References?`)
};

const es_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Algún momento divertido o referencia interna?`)
};

const fr_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des moments amusants ou des références internes ?`)
};

const de_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gibt es lustige Momente oder Insider-Witze?`)
};

const ja_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`面白い瞬間や身内ネタはありますか？`)
};

const zh_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有什么搞笑瞬间或内部梗吗？`)
};

const ar_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أي لحظات مضحكة أو نكات داخلية؟`)
};

const id_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada Momen Lucu atau Referensi Internal?`)
};

const it_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ci sono momenti divertenti o riferimenti interni?`)
};

const ru_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Есть ли смешные моменты или внутренние шутки?`)
};

const pt_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algum momento engraçado ou referências internas?`)
};

const ko_any_funny_moments_or_inside_references = /** @type {(inputs: Any_Funny_Moments_Or_Inside_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`재미있는 순간이나 우리만의 유머가 있나요?`)
};

/**
* | output |
* | --- |
* | "Any Funny Moments or Inside References?" |
*
* @param {Any_Funny_Moments_Or_Inside_ReferencesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const any_funny_moments_or_inside_references = /** @type {((inputs?: Any_Funny_Moments_Or_Inside_ReferencesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Any_Funny_Moments_Or_Inside_ReferencesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_any_funny_moments_or_inside_references(inputs)
	if (locale === "es") return es_any_funny_moments_or_inside_references(inputs)
	if (locale === "fr") return fr_any_funny_moments_or_inside_references(inputs)
	if (locale === "de") return de_any_funny_moments_or_inside_references(inputs)
	if (locale === "ja") return ja_any_funny_moments_or_inside_references(inputs)
	if (locale === "zh") return zh_any_funny_moments_or_inside_references(inputs)
	if (locale === "ar") return ar_any_funny_moments_or_inside_references(inputs)
	if (locale === "id") return id_any_funny_moments_or_inside_references(inputs)
	if (locale === "it") return it_any_funny_moments_or_inside_references(inputs)
	if (locale === "ru") return ru_any_funny_moments_or_inside_references(inputs)
	if (locale === "pt") return pt_any_funny_moments_or_inside_references(inputs)
	return ko_any_funny_moments_or_inside_references(inputs)
});